import { sidePanelStateLocalStorageName } from 'src/utils/config';
import sidePanelState from 'src/models/SidePanelState';
import * as types from '../mutation-types';

// initial state
const state = {
  opened: true,
};

// getters
const getters = {

};

// actions
const actions = {
  toggleSidePanel({ commit }, val) {
    commit(types.TOGGLE_SIDE_PANEL, val);
    const sidePanelNewState = state.opened ? sidePanelState.opened : sidePanelState.closed;
    localStorage.setItem(sidePanelStateLocalStorageName, sidePanelNewState);
  },
};

// mutations
const mutations = {
  [types.TOGGLE_SIDE_PANEL](s, val) {
    s.opened = val; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/sidePanel.js